import { render, staticRenderFns } from "./GameResult.vue?vue&type=template&id=8e5df23e&scoped=true"
import script from "./GameResult.vue?vue&type=script&lang=js"
export * from "./GameResult.vue?vue&type=script&lang=js"
import style0 from "./GameResult.vue?vue&type=style&index=0&id=8e5df23e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5df23e",
  null
  
)

export default component.exports